import { createRouter, createWebHistory } from 'vue-router';

import Default from '@/module/Home/page/Default.vue';
import Notfound from '@/module/Static/Notfound/page/Notfound.vue';

import Landing from '@/module/Landing/page/Landing.vue';
import Home from '@/module/Home/page/Home.vue';
import Campaign from '@/module/Detail/page/Campaign.vue';
import CampaignSurvey from '@/module/Detail/page/campaignSurvey.vue';
import Activity from '@/module/List/page/Activity.vue';
import History from '@/module/History/page/History.vue';
import Notification from "@/module/NotiList/page/Notification.vue"
import HistoryReward from '@/module/History/page/HistoryReward.vue';

import Faq from '@/module/Static/FAQ/page/Faq.vue';
import Badge from '@/module/Badge/page/Badge.vue';
import Contactus from '@/module/Static/contactus/page/Contactus.vue';
import Pdpa from '@/module/Static/Pdpa/page/Pdpa.vue';

import Terms from '@/module/Static/Terms/page/Terms.vue'

import Profile from '@/module/Profile/page/Profile.vue'
import EditProfile from '@/module/Profile/page/EditProfile.vue'
import Other from '@/module/Profile/page/Other.vue'


import Search from '@/module/Search/page/Search.vue'
import HelpChat from "@/module/Helpchat/page/Helpchat.vue";
import HelpchatComment from "@/module/Helpchat/page/HelpchatComment.vue"

import SurpriseBox from "@/module/SurpriseBox/page/SurpriseBox.vue";

import FriendGetFriendVue from '@/module/FriendGetFriend/page/FriendGetFriend.vue';
import promocodeVue from '@/module/Promocode/page/promocode.vue';
import GetCode from '@/module/FriendGetFriend/page/GetCode.vue'
const routes = [
    {
        path: '/',
        name: 'default',
        component: Default
    },
    {
        path: '/home',
        name: 'home',
        component: Home
    },
    {
        path: '/landing',
        name: 'landing',
        component: Landing
    },
    {
        path: '/campaign/:campaignId',
        name: 'campaign',
        component: Campaign
    },
    {
        path: '/CampaignSurvey/:campaignId',
        name: 'CampaignSurvey',
        component: CampaignSurvey
    },
    {
        path: '/activity',
        name: 'activity',
        component: Activity
    },
    {
        path: '/history',
        name: 'history',
        component: History
    },
    {
        path: '/notification',
        name: 'notification',
        component: Notification,
    },
    {
        path: '/reward',
        name: 'reward',
        component: HistoryReward
    },
    {
        path: '/badge',
        name: 'badge',
        component: Badge
    },
    {
        path: '/:catchAll(.*)',
        component: Notfound,
    },
    {
        path: '/faq',
        name: 'Faq',
        component: Faq
    },
    {
        path: '/contactus',
        name: 'Contactus',
        component: Contactus
    },
    {
        path: '/privacy',
        name: 'privacy',
        component: Pdpa
    },
    {
        path: '/terms',
        name: 'terms',
        component: Terms
    },
    {
        path: '/other',
        name: 'other',
        component: Other
    },
    {
        path: '/profile',
        name: 'profile',
        component: Profile
    },
    {
        path: '/editprofile',
        name: 'edit profile',
        component: EditProfile
    },
    {
        path: '/helpchat',
        name: 'helpchat',
        component: HelpChat,
    },
    {
        path: '/helpchatComment/:id',
        name: 'helpchatComment',
        component: HelpchatComment,
    },
    {
        path: '/search',
        name: 'search',
        component: Search,
    },
    {
        path: '/surprisebox/:fortunename/:campaignId',
        name: 'surprisebox',
        component: SurpriseBox,
    },
    {
        path: '/friendgetfriend',
        name: 'friendgetfriend',
        component: FriendGetFriendVue,
    },
    {
        path: '/promocode',
        name: 'promocode',
        component: promocodeVue,
    },
    {
        path: '/getcode',
        name: 'getcode',
        component: GetCode,
    }
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
});

export default router;
